import {
  useApi,
  UserFilteringDtoOptions,
  Users200Response,
  UserSortingDtoOptions,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { UserQueryMode } from '@issuemanager/constants';
import { InfiniteData, useInfiniteQuery } from '@tanstack/react-query';

export type UseInfiniteUsersParams = {
  sort?: UserSortingDtoOptions;
  filter?: UserFilteringDtoOptions;
  page?: number;
  limit?: number;
  enabled?: boolean;
  handleError?: boolean;
};

export function useInfiniteUsers(params: UseInfiniteUsersParams = {}) {
  const {
    page = 0,
    limit = 10,
    sort,
    filter,
    enabled = true,
    handleError = false,
  } = params;

  const filters = {
    ...filter,
    searchTerm: filter?.searchTerm ?? '',
    queryMode: filter?.queryMode ?? UserQueryMode.ALL_USERS,
  };

  const api = useApi();

  const queryKey = ['users', page, limit, sort, filters, enabled];

  return useInfiniteQuery<
    Users200Response,
    ExtendedAxiosError,
    InfiniteData<Users200Response>,
    typeof queryKey,
    number
  >({
    queryKey,
    queryFn: ({ pageParam }) =>
      api.usersApi.users(pageParam, limit, sort, filters).then((r) => r.data),
    enabled,
    initialPageParam: page,
    getNextPageParam: (lastPage) =>
      lastPage.meta.hasNextPage ? lastPage.meta.page + 1 : undefined,
    meta: {
      handleError,
    },
  });
}
